(() => {
  document.documentElement.setAttribute('data-aureme-faq-js-enabled', '');

  window.AuremeFaqBootstrap = window.AuremeFaqBootstrap || {};
  const bootstrap = window.AuremeFaqBootstrap;
  const getUrlWithoutHash = () => window.location.pathname + window.location.search;

  const restoreScrollRestoration = () => {
    if (bootstrap.prevScrollRestoration && 'scrollRestoration' in history) {
      history.scrollRestoration = bootstrap.prevScrollRestoration;
      bootstrap.prevScrollRestoration = undefined;
    }
  };

  const releasePendingState = () => {
    document.documentElement.removeAttribute('data-aureme-faq-hash-pending');
    bootstrap.initialHash = '';
    if (bootstrap.hashPendingTimer) {
      window.clearTimeout(bootstrap.hashPendingTimer);
      bootstrap.hashPendingTimer = null;
    }
    restoreScrollRestoration();
  };

  bootstrap.initialHash = '';
  bootstrap.hashPendingTimer = null;
  bootstrap.releasePendingState = releasePendingState;

  try {
    const rawHash = window.location.hash.slice(1);
    // ハンドル形式のみ許可する
    const handle = /^[a-z0-9][a-z0-9-]{0,63}$/i.test(rawHash) ? rawHash : '';
    if (!handle) return;

    if ('scrollRestoration' in history) {
      bootstrap.prevScrollRestoration = history.scrollRestoration;
      history.scrollRestoration = 'manual';
    }

    bootstrap.initialHash = `#${handle}`;
    document.documentElement.setAttribute('data-aureme-faq-hash-pending', '');

    // このスクリプトは parser-blocking で head 内から同期実行され、対象の .aureme-faq-page__group は
    // まだ body 側に存在しないため、要素へ直接 class を付けられない。CSSOM にルールを先回りで
    // 追加しておき、要素が生成された時点で自動的に対象カテゴリだけ表示されるようにする
    const sheet = document.getElementById('aureme-faq-bootstrap-style')?.sheet;
    if (!sheet) {
      releasePendingState();
      return;
    }
    sheet.insertRule(
      `html[data-aureme-faq-hash-pending] .aureme-faq-page__group[id="${handle}"] { display: flex; }`,
      sheet.cssRules.length,
    );

    // ブラウザ標準のハッシュジャンプを抑止する（本文は data-aureme-faq-hash-pending 中は
    // opacity:0 のため、先にジャンプされると後続の FAQ JS によるスクロールと二重に動いてしまう）
    history.replaceState(history.state, '', getUrlWithoutHash());

    // FAQ JS が起動しない場合でも内容を読める状態へ復旧する
    bootstrap.hashPendingTimer = window.setTimeout(() => {
      const initialHash = bootstrap.initialHash;
      document.documentElement.removeAttribute('data-aureme-faq-hash-pending');
      if (initialHash) {
        history.replaceState(history.state, '', getUrlWithoutHash() + initialHash);
        document.getElementById(initialHash.slice(1))?.scrollIntoView({
          block: 'start',
          behavior: 'auto',
        });
      }
      releasePendingState();
    }, 2000);
  } catch {
    releasePendingState();
  }
})();
